import OrderTypeEnum from '@/api/Enums/OrderTypeEnum.js'
import KdsOrderStatusEnum from '@/api/Enums/KdsOrderStatusEnum.js'
import KdsOrderItemStatusEnum from '@/api/Enums/KdsOrderItemStatusEnum.js'

export default {
  Title: 'KDS',

  List: {
    NoData: {
      Icon            : 'mdi-basket-off-outline',
      IconColor       : 'light-blue',
      Title           : 'No orders available',
      TitleOpen       : 'No open {source} orders available',
      TitleOnHold     : 'No on-hold {source} orders available',
      TitleCompleted  : 'No completed {source} orders available',
      TitleCanceled   : 'No canceled {source} orders available',
      SourceTable     : 'table',
      SourceDelivery  : 'delivery',
      SourceCollection: 'collection',
      Subtitle        : ''
    }
  },

  Dialog: {
    Actions: {
      Toolbar: {
        Title   : '',
        Subtitle: '',
        Icon    : 'mdi-history'
      }
    }
  },

  OrderType: {
    All: {
      Id   : OrderTypeEnum.ALL,
      Code : '0',
      Name : 'All',
      Color: ''
    },
    Table: {
      Id   : -1,
      Code : '-1',
      Name : 'Table',
      Color: 'brown'
    },
    Collection: {
      Id   : OrderTypeEnum.COLLECTION,
      Code : '2',
      Name : '@:Order.Type.Item.Collection.Title',
      Icon : '@:Order.Type.Item.Collection.Icon',
      Color: '@:Order.Type.Item.Collection.Color'
    },
    Delivery: {
      Id   : OrderTypeEnum.DELIVERY,
      Code : '1',
      Name : '@:Order.Type.Item.Delivery.Title',
      Icon : '@:Order.Type.Item.Delivery.Icon',
      Color: '@:Order.Type.Item.Delivery.Color'
    }
  },

  Action: {
    Order: {
      Complete: {
        Name : 'Complete',
        Color: 'green',
        Icon : 'mdi-check'
      },
      Hold: {
        Name : 'Hold',
        Color: 'grey darken-1',
        Icon : 'mdi-timer-pause-outline'
      },
      Resume: {
        Name : 'Resume',
        Color: 'blue',
        Icon : 'mdi-timer-play-outline'
      },
      Revert: {
        Name : 'Recall',
        Color: 'orange',
        Icon : 'mdi-undo'
      },
      Cancel: {
        Name : 'Cancel',
        Color: 'red',
        Icon : 'mdi-close'
      },
      Forward: {
        Name : 'Forward',
        Color: 'blue-grey',
        Icon : 'mdi-rewind-outline'
      },
      Backward: {
        Name : 'Backward',
        Color: 'blue-grey',
        Icon : 'mdi-fast-forward-outline'
      },
      First: {
        Name : 'First',
        Color: 'cyan',
        Icon : 'mdi-skip-backward'
      },
      Last: {
        Name : 'Last',
        Color: 'cyan',
        Icon : 'mdi-skip-forward'
      }
    },

    Item: {
      Complete: {
        Name : 'Complete',
        Color: 'green',
        Icon : 'mdi-check'
      },
      Hold: {
        Name : 'Hold',
        Color: 'grey darken-1',
        Icon : 'mdi-pause'
      },
      Revert: {
        Name : 'Recall',
        Color: 'orange',
        Icon : 'mdi-undo'
      },
      Start: {
        Name : 'Start',
        Color: 'blue',
        Icon : 'mdi-play'
      },
      Cancel: {
        Name : 'Cancel',
        Color: 'red',
        Icon : 'mdi-close'
      }
    }
  },


  Status: {
    Order: {
      Open: {
        Id   : 1,
        Code : KdsOrderStatusEnum.OPEN,
        Name : 'Open',
        Color: 'blue',
        Icon : 'mdi-bullseye'
      },

      Hold: {
        Id   : 2,
        Code : KdsOrderStatusEnum.HOLD,
        Name : 'On-Hold',
        Color: 'grey',
        Icon : 'mdi-pause'
      },

      Complete: {
        Id   : 3,
        Code : KdsOrderStatusEnum.COMPLETE,
        Name : 'Completed',
        Color: 'green',
        Icon : 'mdi-check'
      },

      Cancel: {
        Id   : 4,
        Code : KdsOrderStatusEnum.CANCEL,
        Name : 'Canceled',
        Color: 'red',
        Icon : 'mdi-close'
      }
    },

    Item: {
      Open: {
        Id   : 1,
        Code : KdsOrderItemStatusEnum.OPEN,
        Name : 'Open',
        Color: 'blue',
        Icon : 'mdi-bullseye'
      },

      Start: {
        Id   : 2,
        Code : KdsOrderItemStatusEnum.START,
        Name : 'Started',
        Color: 'blue',
        Icon : 'mdi-play'
      },

      Hold: {
        Id   : 3,
        Code : KdsOrderItemStatusEnum.HOLD,
        Name : 'On-Hold',
        Color: 'grey',
        Icon : 'mdi-pause'
      },

      Complete: {
        Id   : 4,
        Code : KdsOrderItemStatusEnum.COMPLETE,
        Name : 'Completed',
        Color: 'green',
        Icon : 'mdi-check'
      },

      Cancel: {
        Id   : 5,
        Code : KdsOrderItemStatusEnum.CANCEL,
        Name : 'Canceled',
        Color: 'red',
        Icon : 'mdi-close'
      }
    }
  }
}
